import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class LeavePolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'updateLeave':
        return this.permissions.update

      case 'deleteLeave':
        return this.permissions.delete

      case 'approveLeave':
        return this.permissions.approve

      case 'manageLeaveDocuments':
        return this.permissions.manage_documents

      case 'manageIncidences':
        return this.permissions.manage_incidences

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default LeavePolicy
